module.exports = __webpack_public_path__ + "img/image5x3.de1216eb.jpg";